export default __webpack_public_path__ + "static/media/UserThree.71573dcc.svg";